import React, { useEffect, useState } from "react";
import { useCookieConsent } from "../context/Cookie/CookieConsentContext";
import { t } from "i18next";

const CookieConsentBanner = () => {
  const { consentGiven, setConsentGiven } = useCookieConsent();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const storedConsent = localStorage.getItem("cookieConsent");
    setIsVisible(!storedConsent);
  }, [consentGiven, isVisible]);

  const handelCookieClick = (flag) => {
    setIsVisible(false);
    setConsentGiven(flag);
  };

  //if (!isVisible) return null;
  return (
    <div
      className="cookie-consent-container"
      id="cookieConsent"
      style={{ display: consentGiven ? "none" : "block" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            {t("cookies1")} &#x1F36A; {t("cookies2")}{" "}
            <a style={{ color: "black" }} href="#">
              {t("privacy_policy")}
            </a>
            .{" "}
            <button
              className="theme-btn theme-btn-secondary me-2"
              id="acceptCookies"
              onClick={() => handelCookieClick(true)}
            >
              {t("accept")}
            </button>
            {/* <button
              className="theme-btn"
              id="declineCookies"
              onClick={() => handelCookieClick(false)}
            >
              {t("decline")}
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
